export function Consulting() {
  return (
    <div className="page">
      <section className="content-section">
        <h1>Consulting Services</h1>
        <p>Practical, growth-oriented technology consulting for startups and fast-growing teams.</p>

        <div className="services-list">
          <div className="service-item">
            <h3>🏢 Product & Technology Strategy</h3>
            <p>We help you validate ideas, define product roadmaps, and make technology decisions that scale.</p>
          </div>

          <div className="service-item">
            <h3>🔄 Digital Transformation</h3>
            <p>Modernize systems, improve customer journeys, and accelerate digital adoption across your organization.</p>
          </div>

          <div className="service-item">
            <h3>☁️ Cloud Architecture</h3>
            <p>Design secure, cost-effective cloud platforms that support growth, resilience, and rapid iteration.</p>
          </div>

          <div className="service-item">
            <h3>🛡️ Security & Compliance</h3>
            <p>Protect your business with practical security assessments, policy guidance, and risk management.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
